const Polyglot = require("node-polyglot");

class Translator {

  constructor(translations){
    this.polyglot = new Polyglot({
      locale: translations.locale,
      interpolation: {
        prefix: "{{",
        suffix: "}}"
      },
      allowMissing: true,
    });

    translations.translations.forEach(val => {
      let translationString;
      if (val.plural){
        translationString = val.translations.join(" |||| ");
      } else {
        translationString = val.translation;
      }

      // translationString = translationString.replace(/{{NUM}}/g, "{{smart_count}}");
      this.polyglot.extend({
        [val.message]: translationString
      });
    });

  }

  tr(msg, num = null, subs = {}) {

    // Find all the variables used in msg (e.g {{NUM}}) and put them in an array
    const vars = [...msg.matchAll(/\{\{(.*?)\}\}/g)];
    var defaultTo = "";
    // if we have a number parse it to an integer
    if (num != null){
      var float = parseFloat(num);
      if (!isNaN(float)){
        // if have successfully have a number, set the smart count
        subs["smart_count"] = float;
        defaultTo = float;
      } else {
        // Default the smart_count to 1, something has gone wrong somewhere
        subs["smart_count"] = 1;
        defaultTo = num;
      }
    }

    // default any unspecified substitutions
    vars.forEach(function(token){
      token = token[1];
      if (!(token in subs) ){
        subs[token] = defaultTo;
      }
    });

    return this.polyglot.t(msg, subs).split(" |||| ")[0];
  }
}

let data = {};
if (typeof GLOBAL_TRANSLATIONS !== "undefined"){
  data = GLOBAL_TRANSLATIONS;
}

export const constructor = Translator;
export const instance = new Translator(data);
export default instance;